// extracted by mini-css-extract-plugin
export default {"switch":"CxJBc7Yq"};